export default __webpack_public_path__ + "static/media/pf.18a00b3a.svg";